<template>
    <v-dialog :max-width="600" v-model="showPopup" :persistent="true">
        <v-card>
            <div class="popup-header text-center">
                <strong class="fs--20 fw--500">Sticker Sparkles</strong>
                <v-icon class="close-icon cursor-pointer" @click="closePopup">{{ closeIcon }}</v-icon>
            </div>
            <v-card-text class="py-8">
                <div class="content-section text-center mt-1 mb-1">
                    <div class="d-flex align-center justify-center">
                        <div class="image">
                            <img src="@/assets/images/Patrick_Loves_You.gif" width="100%" alt="">
                            <p class="pink--text mt-5 fw--600 ml-7 text-center">Standard</p>
                        </div>
                        <div class="mx-4">
                            <v-icon color="white" size="60">{{ doubleArrow }}</v-icon>
                        </div>
                        <div class="image">
                            <SparkleBox>
                                <img src="@/assets/images/Patrick_Loves_You.gif" width="100%" alt="">
                                <p class="pink--text mt-5 fw--600 text-right">Sparkles Enabled</p>
                            </SparkleBox>
                        </div>
                    </div>

                    <p class="fieldFore--text">Subscribe to any Tier of <strong class="lightBlue--text">Stream Stickers
                            Premium</strong> to enable optional "Sticker Sparkle" effects when you use stickers on all
                        channels.</p>

                    <p class="fieldFore--text fs--10">
                        <i>Please note that sparkles will not appear on your stickers during a Sticker Party for
                            performance reasons.</i>
                    </p>

                    <v-btn color="pink" depressed class="px-10 py-4 mt-3" @click="closePopup">Close</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed, watch } from '@vue/composition-api';
import { mdiClose, mdiChevronLeftCircle, mdiChevronDoubleRight } from '@mdi/js';
import SparkleBox from '@/components/SparkleBox.vue';
export default {
    components: {
        SparkleBox
    },
    props: {
        modal: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const showPopup = computed({
            get() {
                return props.modal;
            },
            set(newValue) {
                if (!newValue) {
                    emit('close', true);
                }
            },
        });

        watch(showPopup, () => {
            console.log(showPopup.value)
            if (showPopup.value) {
                setTimeout(() => {
                    actions.startSparkling();
                }, 50);
            }
        })


        const closePopup = () => {
            emit('close', true);
        };
        return {
            closePopup,
            showPopup,
            closeIcon: mdiClose,
            chevron: mdiChevronLeftCircle,
            doubleArrow: mdiChevronDoubleRight
        };
    },
};
</script>

<style lang="scss">
.popup-header {
    position: relative;
    padding: 12px 0;
    height: 50px;
    background: url('../../../assets/images/backgrounds/sticker-upload-header.png');
    background-repeat: no-repeat;
    background-size: cover;

    .close-icon {
        position: absolute;
        top: 15px;
        right: 15px;
    }
}

.content-section {
    width: 100%;
    margin: auto;
    // overflow-y: scroll;
    // overflow-x: hidden;
    // scrollbar-width: 4px;
    // scrollbar-color: var(-v--pink-base);

    .image {
        width: 125px;
    }
}
</style>
